<template>
  <el-dialog
    width="600px"
    class="hx-to-create-template"
    :title="listParams.id ? '编辑保障用户' : '新增保障用户'"
    :visible.sync="_dialogVisible"
    @close="resetDialogForm"
    :close-on-click-modal="false"
  >
    <el-form ref="dialogForm" :model="listParams" :rules="checkItemParams" label-width="120px">
      <template>
        <!-- 新增时字段 -->
        <el-form-item label="保障手机号：" prop="mobile" v-if="!listParams.id">
          <el-input size="small" placeholder="请输入保障手机号" v-model="listParams.mobile"></el-input>
        </el-form-item>

        <!-- 编辑时字段 -->
        <el-form-item label="保障手机号：" prop="updatePhone" v-else>
          <el-input size="small" placeholder="请输入保障手机号" v-model="listParams.updatePhone"></el-input>
        </el-form-item>
      </template>

      <el-form-item label="供应点：" prop="logisticsSiteId">
        <el-select style="width: 100%" v-model="listParams.logisticsSiteId" size="small" placeholder="请选择供应点">
          <el-option v-for="item in supplyCentreList" :label="item.title" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="保障级别：" prop="supplyLevelId">
        <el-select style="width: 100%" v-model="listParams.supplyLevelId" size="small" placeholder="请选择保障级别">
          <el-option v-for="item in levelList" :label="item.levelName" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <div class="align-center">
        <el-button :disabled="isDisabled" size="small" type="primary" @click="handleSubmit('dialogForm')">保 存</el-button>
        <el-button size="small" @click="_dialogVisible = false">取 消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from "vue";

const defaultItemParams = {
  mobile: "",
  logisticsSiteId: "",
  supplyLevelId: "",
  supplyId: ""
};

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    },
    supplyId: {
      type: String,
      default: ""
    }
  },

  watch: {
    dialogVisible: {
      immediate: true,
      handler(value) {
        if (value && this.supplyId) {
          this.listParams = Object.assign({}, defaultItemParams, { supplyId: this.supplyId }, this.dialogData);
          this.loadLevelList();
          this.loadSupplyCentreList();
        }
      }
    }
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(value) {
        this.$emit("update:dialogVisible", value);
      }
    }
  },

  data() {
    return {
      isDisabled: false,
      listParams: Object.assign({}, defaultItemParams),
      levelList: [],
      supplyCentreList: [],
      checkItemParams: {
        mobile: [{ required: true, message: "请输入保障手机号", trigger: "blur" }],
        updatePhone: [{ required: true, message: "请输入保障手机号", trigger: "blur" }],
        supplyLevelId: [{ required: true, message: "请选择保障级别", trigger: "blur" }],
        logisticsSiteId: [{ required: true, message: "请选择供应点", trigger: "blur" }]
      }
    };
  },

  methods: {
    /**
     * 初始化供应点列表
     */
    async loadSupplyCentreList() {
      const params = { supplyId: this.supplyId };
      try {
        const url = global.apiUrl + "/logistics/index";
        const response = await Vue.ajaxGet(this, url, params, "tableLoading");
        this.supplyCentreList = response.dataList || [];
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 加载保障级别列表
     */
    async loadLevelList() {
      const params = { supplyId: this.supplyId, pageIndex: 1, pageSize: 999 };
      try {
        const url = global.apiUrl + "/supply/level";
        const response = await Vue.ajaxGet(this, url, params, "tableLoading");
        this.levelList = response.data || [];
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 保存新增或修改
     * @param {*} name
     */
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            let response = null;
            this.isDisabled = true;
            if (this.listParams.id) {
              const url = global.apiUrl + "/supply/editSupplyUser";
              response = await Vue.ajaxPut(this, url, this.listParams, "isDisabled");
            } else {
              const url = global.apiUrl + "/supply/supplyUserReserve";
              response = await Vue.ajaxPost(this, url, this.listParams, "isDisabled");
            }
            this.$message.success(response.info);
            this.handleClose();
            this.$emit("refresh");
          } catch (error) {
            console.log(error);
          }
        } else {
          this.isDisabled = false;
        }
      });
    },

    /**
     * 关闭
     */
    handleClose() {
      this._dialogVisible = false;
      this.isDisabled = false;
    },

    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
      this.listParams = Object.assign({}, defaultItemParams);
    }
  }
};
</script>
